/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. ATGGCCGCTGCAGCG...`)
};

const es_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. ATGGCCGCTGCAGCG...`)
};

const de_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. ATGGCCGCTGCAGCG...`)
};

const nl_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. ATGGCCGCTGCAGCG...`)
};

const fr_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. ATGGCCGCTGCAGCG...`)
};

const it_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. ATGGCCGCTGCAGCG...`)
};

const pt_br2_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex.: ATGGCCGCTGCAGCG...`)
};

const pt_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por ex. ATGGCCGCTGCAGCG...`)
};

const ja_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: ATGGCCGCTGCAGCG...`)
};

const zh_codon_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 ATGGCCGCTGCAGCG...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_input_placeholder", locale)
	if (locale === "en") return en_codon_input_placeholder(inputs)
	if (locale === "es") return es_codon_input_placeholder(inputs)
	if (locale === "de") return de_codon_input_placeholder(inputs)
	if (locale === "nl") return nl_codon_input_placeholder(inputs)
	if (locale === "fr") return fr_codon_input_placeholder(inputs)
	if (locale === "it") return it_codon_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_codon_input_placeholder(inputs)
	if (locale === "pt") return pt_codon_input_placeholder(inputs)
	if (locale === "ja") return ja_codon_input_placeholder(inputs)
	return zh_codon_input_placeholder(inputs)
};